/* eslint-disable max-len */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import appConfig from 'app-config';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import { useTranslator } from '@jutro/locale';

import metadata from './MLHOPropertyValuationComponent.metadata.json5';
import messages from './MLHOPropertyValuationComponent.messages';
import styles from './MLHOPropertyValuationComponent.module.scss';
import { MLModalService } from 'ml-portals-services-react';
import { platformMessages } from 'ml-components-platform-react';

function MLHOPropertyValuationComponent(props) {
    const translator = useTranslator();
    const {
        token,
        onFinish,
        onError
    } = props;
    const isAmp = appConfig.portalCode === 'AMP';
    const { runtimeEnv = '' } = appConfig;

    const [iframeURL, setIframeURL] = useState();
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    const {
        showProgressDialog,
        hideProgressDialog
    } = MLModalService();

    const updateWindowWidth = () => {
        setWindowWidth(window.innerWidth);
    };
    const veriskIntegrationListener = (event) => {
        if (event.data.fromEvent === 'veriskIntegration') {
            const { data } = event;
            if (data.action === 'finish') {
                onFinishVerisk(data.veriskData);
            } else if (data.action === 'onCriticalError') {
                onError(_.get(data, 'veriskErrorData.message', undefined));
            } else if (data.action === 'sessionTimeOut') {
                onError(translator(messages.sessionTimeout));
            } else {
                // eslint-disable-next-line no-console
                console.error(new Error('Unidentified Verisk interaction'));
            }
        }
    }


    useEffect(() => {
        if (token) {
            const veriskURL = (runtimeEnv === 'prod' || runtimeEnv === 'dryrun')? 'https://www.360-value.com' : 'https://acceptance.360-value.com';
            const veriskScriptLink = encodeURIComponent(`${veriskURL}/apps/iv/statics`);
            const veriskCSSLink = encodeURIComponent(`${veriskURL}/apps/iv/resources/client/defaultTemplateThemes/default.css`);
            setIframeURL(`${window.location.protocol}//${window.location.host}/html/ml-verisk-property-valuation-plugin.html?tokenstring=${token}&veriskScriptURL=${veriskScriptLink}&veriskCSSURL=${veriskCSSLink}`);
        } else {
            onError(translator(messages.noToken));
        }
        window.addEventListener('resize', updateWindowWidth);
        window.addEventListener('message', veriskIntegrationListener);

        return () => {
            window.removeEventListener('resize', updateWindowWidth);
            window.removeEventListener('message', veriskIntegrationListener)
        }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        const isMobile = window.innerWidth <= 768;
        
        if (!isMobile) return;

        showProgressDialog(platformMessages.loading);

        const timer = setTimeout(() => {
            hideProgressDialog();
        }, 5000);

        return () => {
            clearTimeout(timer);
            hideProgressDialog();
        };
    }, []);

    const onFinishVerisk = (data) => {
        onFinish(data.valuationId, data.version);
    };

    


    /** This function takes its height values from the module.scss file.
     *  Height for iFrames in Jutro is not applied as style but as a property.
     * @returns {string} iframe's height
     */
    const getIframeHeight = () => {
        if (isAmp) {
            if (windowWidth <= 768) {
                return '3400px';
            }
            return '2800px';
        }
        if (windowWidth <= 768) {
            return '3100px';
        }
        if (windowWidth <= 1200) {
            return '2400px';
        }
        return '1100px';
    };

    const overrides = {
        verisk360Frame: {
            src: iframeURL,
            height: getIframeHeight(),
            frameBorder: 0,
            margin: 0,
            scrolling: 'no',
            className: !isAmp && 'iframeBorder'
        }
    };

    const resolvers = {
        resolveClassNameMap: styles
    };

    return (
        <MetadataContent
            uiProps={metadata.componentContent}
            overrideProps={overrides}
            {...resolvers} />
    );
}

MLHOPropertyValuationComponent.propTypes = {
    propertyValuationData: PropTypes.shape({}).isRequired,
    onFinish: PropTypes.func.isRequired,
    onError: PropTypes.func.isRequired,
    updatePropertyValuationData: PropTypes.func.isRequired
};

export default MLHOPropertyValuationComponent;